import React from "react";
import {
  ensureMailApnaArtistComposer,
  ensureMailApnaArtistTemplate,
} from "../../shared/types/mailApnaArtist";

export default function MailApnaArtistPreview({composer, template, compact = false}) {
  const safeTemplate = ensureMailApnaArtistTemplate(template);
  const safeComposer = ensureMailApnaArtistComposer(composer);
  const highlights = (safeTemplate.highlights || []).filter(Boolean).slice(0, 3);
  const attachments = (safeComposer.attachments || []).filter((item) => item?.fileName);
  const footerContacts = [
    safeTemplate.footerAddress,
    safeTemplate.footerPhone,
    safeTemplate.footerWebsite,
  ].filter(Boolean);

  return (
    <div
      className={`mail-aa-preview-shell ${compact ? "is-compact" : ""}`}
      style={{
        "--mail-aa-primary": safeTemplate.primaryColor,
        "--mail-aa-secondary": safeTemplate.secondaryColor,
        "--mail-aa-button": safeTemplate.buttonColor,
        "--mail-aa-bg": safeTemplate.backgroundColor,
      }}
    >
      <div className="mail-aa-preview-frame">
        <div className="mail-aa-preview-topbar">
          <span>Live Email Preview</span>
          <span>{safeComposer.subject || "Draft preview"}</span>
        </div>

        <div className="mail-aa-preview-email">
          {safeTemplate.showLogo ? (
            <div className="mail-aa-preview-logoRow">
              <img
                className="mail-aa-preview-logo"
                src={
                  !safeTemplate.logoUrl || safeTemplate.logoUrl === "/logo512.png"
                    ? "/brand/apnaartist-cream.png"
                    : safeTemplate.logoUrl
                }
                alt="ApnaArtist"
              />
              <div>
                <div className="mail-aa-preview-brand">ApnaArtist</div>
                <div className="mail-aa-preview-brandSub">by Kalakaarpanti studios Pvt Ltd</div>
              </div>
            </div>
          ) : null}

          {safeTemplate.showBanner ? (
            <div className="mail-aa-preview-hero">
              {safeTemplate.bannerImageUrl ? (
                <img
                  className="mail-aa-preview-heroImage"
                  src={safeTemplate.bannerImageUrl}
                  alt={safeTemplate.bannerAlt || "ApnaArtist outreach banner"}
                />
              ) : null}
              <div className="mail-aa-preview-heroCopy">
                <div className="mail-aa-preview-kicker">APNAARTIST MAIL</div>
                <h3>{safeTemplate.bannerTitle}</h3>
                <p>{safeTemplate.bannerSubtitle}</p>
              </div>
            </div>
          ) : null}

          <div className="mail-aa-preview-card">
            <div className="mail-aa-preview-subject">
              {safeComposer.subject || "Your campaign subject will appear here"}
            </div>
            <div className="mail-aa-preview-subjectRule" />

            <div className="mail-aa-preview-meta">
              <span>From: {safeComposer.senderDisplayName || safeComposer.senderEmail || "Select sender"}</span>
              <span>To: {safeComposer.toText || "Add recipients"}</span>
            </div>

            <div className="mail-aa-preview-body">
              {(safeComposer.body || "").split("\n").map((line, index) => (
                <p key={`${line}-${index}`}>{line || "\u00A0"}</p>
              ))}
            </div>

            {safeTemplate.showHighlights && highlights.length > 0 ? (
              <div className="mail-aa-preview-highlights">
                {highlights.map((item, index) => (
                  <div key={item} className="mail-aa-preview-highlight">
                    <span>{["✦", "●", "✓"][index] || "✓"}</span>
                    <strong>{item}</strong>
                  </div>
                ))}
              </div>
            ) : null}

            {safeTemplate.showCta ? (
              <a className="mail-aa-preview-cta" href={safeComposer.ctaUrl || "#"}>
                <span>▶</span> {safeComposer.ctaLabel || "Call to action"}
              </a>
            ) : null}

            {attachments.length > 0 ? (
              <div className="mail-aa-preview-attachments">
                {attachments.map((item) => (
                  <span key={item.id || item.fileName} className="mail-aa-preview-attachmentChip">
                    {item.fileName}
                  </span>
                ))}
              </div>
            ) : null}
          </div>

          {safeTemplate.showFooter ? (
            <div className="mail-aa-preview-footer">
              <div className="mail-aa-preview-footerCard">
                <div className="mail-aa-preview-footerBrand">
                  <span className="mail-aa-preview-footerEyebrow">ApnaArtist Network</span>
                  {safeTemplate.footerText ? <div className="mail-aa-preview-footerText">{safeTemplate.footerText}</div> : null}
                </div>

                {footerContacts.length > 0 ? (
                  <div className="mail-aa-preview-footerMeta">
                    {footerContacts.map((item) => (
                      <span key={item} className="mail-aa-preview-footerPill">{item}</span>
                    ))}
                  </div>
                ) : null}

                {safeTemplate.socialLine ? <div className="mail-aa-preview-footerSocialLine">{safeTemplate.socialLine}</div> : null}

                <div className="mail-aa-preview-socials">
                {Object.entries(safeTemplate.socialLinks || {})
                  .filter(([, value]) => value)
                  .map(([key, value]) => (
                    <span key={key} className="mail-aa-preview-socialChip">{key}: {value}</span>
                  ))}
                </div>
              </div>

              <div className="mail-aa-preview-unsub">
                Reply tracking placeholder only. Open and click tracking are intentionally not active in Phase 3.
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
